import React from 'react';
import '../less/index.less'
import hero_img from '../img/hero_img.png';
import Hero from '../../../../../../../auxiliary-components/shared/HeroBlock';
import Advantages from '../../../../../../../auxiliary-components/shared/AdvantagesBlock';
import advantages_img_1 from '../img/advantages_img_1.png';
import advantages_img_2 from '../img/advantages_img_2.png';
import advantages_img_3 from '../img/advantages_img_3.png';
import advantages_img_4 from '../img/advantages_img_4.png';
import Tariffs from '../../../../../../../auxiliary-components/shared/TariffsBlock';
import advantagesItemsData from '../enums/advantages_items.json';
import tariffsData from '../enums/tariffs_data.json';
import InfoBlock from '../../../../../../../auxiliary-components/shared/InfoBlock';
import TextBlock from './../../../../../../../auxiliary-components/shared/TextBlock/index';

export default function template() {
  const hero_data = {
    title: 'LOANS_DAYTODAY_OPERATIONS_HERO_TITLE',
    text: 'LOANS_DAYTODAY_OPERATIONS_HERO_TEXT'
  }

  const imagesMap = {
    advantages_img_1,
    advantages_img_2,
    advantages_img_3,
    advantages_img_4
  }

  const advantagesItems = advantagesItemsData.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="loans-daytoday-operations">
      <Hero
        data={hero_data}
        img={hero_img}
        className={"loans-corporate-clients"}
      />
      <div className="content">
        <>
          <Advantages
            items={advantagesItems}
            title={'LOANS_DAYTODAY_OPERATIONS_ADVANTAGES_TITLE'}
          />
          <div>
            <Tariffs
              items={tariffsData}
              title={'LOANS_DAYTODAY_OPERATIONS_CARDS_TARIFFS_TITLE'}
              alignItems="start"
            />
            <TextBlock text={'LOANS_DAYTODAY_OPERATIONS_TEXT'}/>
            <InfoBlock 
              text={'LOANS_DAYTODAY_OPERATIONS_INFO_TEXT_01'}
            />
          </div>
          <InfoBlock 
            title={'LOANS_DAYTODAY_OPERATIONS_INFO_TITLE_02'}
            text={'LOANS_DAYTODAY_OPERATIONS_INFO_TEXT_02'}
          />
        </>
      </div>
    </div>
  );
}
